import request from './request';

const videoPlatformMediaService = {
    search: (show, startDate, endDate) => {
        return request({
            method: "get",
            url: `videoplatformmedia/${encodeURI(show)}`,
            params: {
                startDate,
                endDate
            }
        });
    },
    purge: (show, startDate, endDate, password) => {
        return request({
            method: "delete",
            url: `videoplatformmedia/${encodeURI(show)}`,
            params: {
                startDate,
                endDate,
                password
            }
        })
    }
};

export default videoPlatformMediaService;